import React, { useContext, useState } from 'react';
import Banner from '../../b2b-common/Banner';
import FrameworksTable from '../components/FrameworksTable';
import B2BFormContainer from '../../b2b-common/B2BFormContainer';
import { fetchAPIDataWhileSettingState } from '../../b2b-common/helpers';
import { Divider } from '@mui/material';
import LevelNsTree from '../components/LevelNsTree';
import { LoginContext } from '../../../App';
import { fetchLevelNsData } from '../../../services/b2b-frameworks-apiService';
import FrameworkImages from '../components/FrameworkImages';
import LevelNImages from '../components/LevelNImages';
import LevelNFields from '../components/LevelNFields';
import LabelTranslated from '../../b2b-languages/components/LabelTranslated';
import B2BIndicatorsTable from '../components/B2BIndicatorsTable';
import { getAllB2BIndicators } from '../components/helper';

import './FrameworksList.css';
import AddB2BIndicatorForm from '../components/AddB2BIndicatorForm';

const FrameworksList = ({ title, frameworkSuite }) => {
    const { loginData } = useContext(LoginContext);
    const [selectedFramework, setSelectedFramework] = useState(null);
    const [selectedLevelN, setSelectedLevelN] = useState(null);
    const [loadingLevelNId, setLoadingLevelNId] = useState(null);
    const [error, setError] = useState(null);

    const handleSelectedFramework = (framework) => {
        //console.log("Selected framework: ", framework);
        setSelectedFramework(framework);
        setSelectedLevelN(null);
    };

    const fetchLevelN = async (frameworkId, levelId) => {
        setLoadingLevelNId(levelId);
        try {
            const paramsArray = [
                frameworkSuite,
                frameworkId,
                levelId,
                loginData.accessToken,
                0,     // depth
                true,  // fetchIndicatorDTOs
                true,  // levelNsAddImages
            ];
            const levelN = await fetchAPIDataWhileSettingState(fetchLevelNsData, paramsArray, null);
            return levelN;
        } catch (error) {
            setError(error.message);
        } finally {
            setLoadingLevelNId(null);
        }
    }

    const handleSelectedLevelN = async (levelNId) => {
        //console.log("Selected LevelN: ", levelNId);
        if (selectedLevelN && (selectedLevelN.levelN_ItemId === levelNId))
            return;
        const levelN = await fetchLevelN(selectedFramework.frameworkId, levelNId);
        setSelectedLevelN(levelN);
    }

    const handleAddB2BIndicator = async () => {
        const levelN = await fetchLevelN(selectedFramework.frameworkId, selectedLevelN.levelN_ItemId);
        setSelectedLevelN(levelN);
    }

    const handleRemovedIndicator = async () => {
        const levelN = await fetchLevelN(selectedFramework.frameworkId, selectedLevelN.levelN_ItemId);
        setSelectedLevelN(levelN);
    }

    //console.log('Selected framework:', selectedFramework);

    return (
        <div className='frameworks-list-page-container'>
            <Banner message={title} />
            <FrameworksTable
                frameworkSuite={frameworkSuite}
                onSelectedFramework={handleSelectedFramework}
            />
            {(selectedFramework && (
                <>
                    <B2BFormContainer
                        title={`${selectedFramework.frameworkAcronym} - ${selectedFramework.frameworkName}`}
                        className={"selected-framework-form"}
                        showDivider={true} buttonsConfig={null}
                        onClose={() => setSelectedFramework(null)}
                    >
                        <div className='selected-framework-main'>
                            <div className='selected-framework-fields'>
                                <LabelTranslated field="Name" labelValue={selectedFramework.frameworkName_label}
                                    locale={`Short name - ${loginData.locale}`} translation={selectedFramework.frameworkName} />
                                <LabelTranslated field="Name" labelValue={selectedFramework.frameworkDescription_label}
                                    locale={`Short name - ${loginData.locale}`} translation={selectedFramework.frameworkDescription}
                                    rowsNumber={4} />
                                <div className='selected-framework-images'>
                                    <FrameworkImages
                                        frameworkSuite={frameworkSuite}
                                        framework={selectedFramework} />
                                </div>
                            </div>
                            <div className='selected-framework-levelns-hierarchy'>
                                <LevelNsTree
                                    subLevels={selectedFramework.subLevels}
                                    onSelectedLevelN={handleSelectedLevelN}
                                    className={"selected-framework-levelns-tree"}
                                />
                            </div>
                        </div>
                        {selectedLevelN && (
                            <>
                                <Divider />
                                <B2BFormContainer
                                    title={`${selectedLevelN.levelN_ItemName} - ${`${selectedLevelN.levelN_ItemName_label}`}`}
                                    className={"selected-leveln-form"}
                                    showDivider={true} buttonsConfig={null}
                                    onClose={() => setSelectedLevelN(null)}
                                >
                                    <div className='selected-framework-levelns'>
                                        <div className='selected-framework-levelns-details'>
                                            <LevelNFields levelN={selectedLevelN} />
                                            <LevelNImages frameworkSuite={frameworkSuite} levelN={selectedLevelN} />
                                        </div>
                                        <div className='selected-framework-levelns-b2bindicators'>
                                            <AddB2BIndicatorForm frameworkSuite={frameworkSuite} framework={selectedFramework} levelN={selectedLevelN}
                                                className='fw-list-new-b2bindicator-form'
                                                onAddedB2BIndicator={handleAddB2BIndicator}
                                            />
                                            <B2BIndicatorsTable
                                                frameworkSuite={frameworkSuite}
                                                b2bindicators={getAllB2BIndicators(selectedLevelN)}
                                                onRemovedIndicator={handleRemovedIndicator}
                                            />
                                        </div>
                                    </div>
                                </B2BFormContainer>
                            </>
                        )}
                    </B2BFormContainer>
                </>
            ))}
        </div>
    );
};

export default FrameworksList;